import { defineMessage } from 'services/localization';

export const messages = {
    day: defineMessage('day'),
    month: defineMessage('month_1'),
    year: defineMessage('year'),
    prediction: defineMessage('next_execution_dates'),
    time: defineMessage('execution_time'),
    endDate: defineMessage('end_date_optional'),
    save: defineMessage('save'),
    title: defineMessage('scheduler'),
    select: defineMessage('select'),
    januaryShort: defineMessage('jan'),
    january: defineMessage('january'),
    februaryShort: defineMessage('feb'),
    february: defineMessage('february'),
    marchShort: defineMessage('mar'),
    march: defineMessage('march'),
    aprilShort: defineMessage('apr'),
    april: defineMessage('april'),
    mayShort: defineMessage('may'),
    may: defineMessage('may'),
    juneShort: defineMessage('jun'),
    june: defineMessage('june'),
    julyShort: defineMessage('jul'),
    july: defineMessage('july'),
    augustShort: defineMessage('aug'),
    august: defineMessage('august'),
    septemberShort: defineMessage('sep'),
    september: defineMessage('september'),
    octoberShort: defineMessage('oct'),
    october: defineMessage('october'),
    novemberShort: defineMessage('nov'),
    november: defineMessage('november'),
    decemberShort: defineMessage('dec'),
    december: defineMessage('december'),
};
